import React from 'react';
import PropTypes from 'prop-types';
import { API } from '../../../constants/api';
import {
  StyledPressNote,
  StyledWrapper,
  StyledNumber,
  StyledName,
  StyledLink,
  StyledIcon,
  StyledDate
} from './style';

import { CHANNELS_ICON_PRESS_RELEASE } from '../../../constants/channels';

const PressRelease = ({ pressRelease }) => (
  <StyledPressNote>
    {pressRelease &&
      pressRelease.map(item => (
        <StyledWrapper key={item.id}>
          <StyledNumber>
            {CHANNELS_ICON_PRESS_RELEASE[item.channelName] && (
              <StyledIcon
                svg={CHANNELS_ICON_PRESS_RELEASE[item.channelName].icon}
                size="m"
              />
            )}
          </StyledNumber>
          <StyledName>
            <StyledLink
              href={`${API}notasdeprensa/${item.fileName}`}
              title={item.name}
            >
              <StyledDate> ({item.creationDate})</StyledDate>
              {` ${item.name}`}
            </StyledLink>
          </StyledName>
        </StyledWrapper>
      ))}
  </StyledPressNote>
);

PressRelease.propTypes = {
  pressRelease: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    })
  ).isRequired
};

export default PressRelease;
